import PropTypes from "prop-types";
import clsx from "clsx";
import {
  getIndividualCategories,
  getIndividualBrands,
  getProductsIndividualRatings,
} from "../../helpers/product";
import ShopSearch from "../../components/product/ShopSearch";
import ShopCategories from "../../components/product/ShopCategories";
import ShopBrands from "../../components/product/ShopBrands";
import ShopRating from "../../components/product/ShopRating";
import { FaSearch } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const ShopSidebar = ({
  categories = true,
  categoriesItems,
  products,
  getSortParams,
  sideSpaceClass,
  setSearch,
  getFilterSortParams,
  minRef,
  maxRef,
  price = true,
  min,
  max,
  setMax,
  setSort,
  setMin,
  categoriesFilter,
  setBrandsFilter,
  brandsFilter,
  ratingFilter,
  setRatingFilter,
  setCategoriesFilter,
}) => {
  const { t } = useTranslation();
  const uniqueCategories = getIndividualCategories(categoriesItems);
  const uniqueBrands = getIndividualBrands(products);
  const uniqueRatings = getProductsIndividualRatings(products);

  return (
    <div className={clsx("sidebar-style m-0 ", sideSpaceClass)}>
      {/* shop search */}
      <ShopSearch
        setSearch={setSearch}
        getFilterSortParams={getFilterSortParams}
      />
      {price && (
        <div className="sidebar-widget">
          <h4 className="pro-sidebar-title mb-4">{t("filter_by_price")} </h4>
          <div className="d-flex gap-2">
            <input
              ref={minRef}
              type="text"
              placeholder={t("min")}
              className="bg-white border-1"
            />
            <input
              ref={maxRef}
              type="text"
              placeholder={t("max")}
              className="bg-white border-1"
            />
          </div>
          <button
            onClick={() => {
              setMin(minRef.current.value);
              setMax(maxRef.current.value);
            }}
            className="btn d-flex gap-2 align-items-center mb-3"
          >
            <FaSearch />
            <span>{t("search")}</span>
          </button>
        </div>
      )}

      {/* filter by categories */}
      {categories && (
        <ShopCategories
          categoriesFilter={categoriesFilter}
          setCategoriesFilter={setCategoriesFilter}
          categoriesItems={categoriesItems}
          categories={uniqueCategories}
          getSortParams={getSortParams}
        />
      )}

      {/* filter by brands */}
      <ShopBrands
        brandsFilter={brandsFilter}
        setBrandsFilter={setBrandsFilter}
        getSortParams={getSortParams}
      />

      {/* filter by rating */}
      <ShopRating
        ratingFilter={ratingFilter}
        setRatingFilter={setRatingFilter}
        ratings={uniqueRatings}
        getSortParams={getSortParams}
      />
    </div>
  );
};

ShopSidebar.propTypes = {
  getSortParams: PropTypes.func,
  products: PropTypes.array,
  sideSpaceClass: PropTypes.string,
};

export default ShopSidebar;
